import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-update-upload-documents-popup',
  templateUrl: './update-upload-documents-popup.component.html',
  styleUrls: ['./update-upload-documents-popup.component.css']
})

export class UpdateUploadDocumentsPopupComponent {

  dataSource: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private apiService: ApiService,
    private dialogRef: MatDialogRef<UpdateUploadDocumentsPopupComponent>
  ) {

    console.log(data);

  }

  ngOnInit(): void {

    this.getUploadedDocuments();

  }

  getUploadedDocuments() {

    const payload = {

      uniqueEventId: this.data.UniqueEventId

    };

    console.log('PAYLOAD:', payload);

    this.apiService
      .getRequest(
        API_ENDPOINTS.IA.GETIAEVENTDOCUMENTSLIST,
        payload
      )
      .subscribe({

        next: (res: any) => {

          console.log('DOCUMENT API RESPONSE:', res);

          this.dataSource = res.data || [];

          console.log('FINAL TABLE DATA:', this.dataSource);

        },

        error: (err) => {

          console.log(err);

        }

      });

  }

  onUploadDocument(row: any) {

    // close popup
    this.dialogRef.close();

    // redirect to upload form
    this.router.navigate(

      ['/Update-Upload-Documents-Form', row.uniqueEventId],
      {
        state: {
          documentData: row
        }
      }
    );

  }

}
